import { graphql } from "gql.tada";
import { RichTextFragment } from "@queries/fragments/RichTextFragment";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { InsightsBlockFragment } from "@queries/fragments/InsightsBlockFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";

export const GetContentHubPageById = graphql(
  `
    query GetContentHubPageById(
      $id: String!
      $locale: String
      $preview: Boolean
    ) {
      contentHubPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        title
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        markets
        navigationAccessibilityLabel
        hero {
          variant
          title
          subtitle
          description
          ctaText
          ctaLink
          backgroundImage {
            url
            contentType
          }
          previewVideo {
            url
            contentType
          }
          fullVideo {
            url
            contentType
          }
          overlayImage {
            url
          }
          eyebrowImagesCollection {
            items {
              url
              contentType
            }
          }
          bodyRichText {
            ...RichTextFragment
          }
          fullWidthImage {
            url
            contentType
          }
        }
        insights {
          blocksCollection {
            items {
              ...InsightsBlockFragment
            }
          }
        }
        routing {
          sys {
            id
          }
          variant
          isVertical
          title
          titleRichText {
            json
          }
          cta {
            ...LinkFragment
          }
          backgroundImage {
            url
            title
          }
        }
      }
    }
  `,
  [RichTextFragment, LinkFragment, InsightsBlockFragment, ThemeFragment, MetadataFragment]
);
